// App.jsx
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import TagManager from "./pages/TagManager";
import Order from "./pages/Order";
import OrderEdit from "./components/OrderEdit";
import { AuthProvider, useAuth } from "./context/AuthContext";

// ✨ shadcn
import { Button } from "./components/ui/button";
import { Separator } from "./components/ui/separator";

function ProtectedRoute({ element }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-4 text-sm text-muted-foreground">Loading…</div>;
  return user ? element : <Navigate to="/" />;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App min-h-screen bg-background text-foreground" dir="rtl">
          <Navbar />
          <main className="container mx-auto px-4 py-4">
            <Routes>
              <Route path="/" element={<Home />} />
              {/* <Route path="/about" element={<About />} /> */}
              <Route path="/tags" element={<ProtectedRoute element={<TagManager />} />} />
              <Route path="/orders" element={<ProtectedRoute element={<Order />} />} />
              {/* <Route path="/insert_order" element={<ProtectedRoute element={<InsertOrder />} />} /> */}
              <Route path="/order_edit/:id" element={<ProtectedRoute element={<OrderEdit />} />} />
            </Routes>
          </main>
        </div>
      </AuthProvider>
    </Router>
  );
}

// Navbar with Login/Logout (shadcn buttons + responsive container)
function Navbar() {
  const { user, login, logout } = useAuth();

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background/80 backdrop-blur">
      <div className="container mx-auto flex h-14 items-center justify-between px-4">
        {/* Left side: nav links */}
        <nav className="flex items-center gap-1">
          <Button variant="link" className="px-2" asChild>
            <Link to="/">דף הבית</Link>
          </Button>
          {/* <Button variant="link" className="px-2" asChild>
            <Link to="/about">About</Link>
          </Button> */}
          {user && (
            <>
              <Button variant="link" className="px-2" asChild>
                <Link to="/tags">ניהול תגיות</Link>
              </Button>
              <Button variant="link" className="px-2" asChild>
                <Link to="/orders">הזמנות</Link>
              </Button>
              {/* <Button variant="link" className="px-2" asChild>
                <Link to="/insert_order">Insert Order</Link>
              </Button> */}
            </>
          )}
        </nav>

        {/* Divider shown only on md+ to structure the header (optional) */}
        <Separator className="mx-3 hidden h-6 md:block" orientation="vertical" />

        {/* Right side: auth action */}
        <div className="flex items-center gap-2">
          {user ? (
            <Button variant="destructive" onClick={logout}>
              התנתק
            </Button>
          ) : (
            <Button onClick={login}>חיבור עם גוגל</Button>
          )}
        </div>
      </div>
    </header>
  );
}

export default App;
